export const ModalSelectors = {
    IsOpen: (state) => state.Modal.isOpen,
    Component: (state) => state.Modal.component,
    Options: (state) => state.Modal.options,
    ModalStack: (state) => state.Modal.modalStack,
};
